import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  migrationId: string;
  noteId: string;
}

interface Result {
  deleted: boolean;
}

const options: ApiOptions = {
  method: 'delete',
  urlPath: '/migration/delete_note',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useDeleteMigrationNoteLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useDeleteMigrationNoteLazy;
